import { Typography } from '@mui/material';

import { RadioClickData } from '@/models/radio.click.data';

import { RadioClicksItem as StyledRadioClicksItem } from '../styles';

interface RadioClicksItemComponentProps {
  item: RadioClickData;
  handleClick: (
    event: React.MouseEvent<HTMLButtonElement>,
    item: RadioClickData,
  ) => void;
  isFirst?: boolean;
  isLast?: boolean;
}

export const RadioClicksItemComponent = ({
  item,
  handleClick,
  isFirst,
  isLast,
}: RadioClicksItemComponentProps) => {
  const classname =
    item.unitId === undefined ? 'disabled' : item.cfs ? 'assigned' : '';
  return (
    <StyledRadioClicksItem
      disabled={item.unitId === undefined}
      sx={{ paddingX: 2 }}
      className={`${classname} ${isFirst ? 'first' : ''} ${
        isLast ? 'last' : ''
      }`}
      onClick={(event) => handleClick(event, item)}
    >
      <Typography fontSize={12} fontWeight={500}>
        {item.equipment || item.radioId}
      </Typography>
    </StyledRadioClicksItem>
  );
};
